<template>
    <div 
        id="ecmSettingsPanel" 
        tabindex="-1"
        v-bind:class="{ open: settingsOpen }">
        
        <FiltersTypes v-if="config.showTypeFilters" />

        <Categories v-if="config.showCategoryFilters" />

        <FiltersExternals v-if="config.externalSources" />

        <MapSettings />

    </div>
</template>

<script>
import FiltersTypes from './FiltersTypes.vue';
import Categories from './Categories.vue';
import FiltersExternals from './FiltersExternals.vue';
import MapSettings from './MapSettings.vue';

export default {
    name: 'SettingsPanel',
    components: {
        FiltersTypes,
        Categories,
        FiltersExternals,
        MapSettings
    },
    computed: {
        config () {
            return this.$store.state.config;
        },
        settingsOpen () {
            return this.$store.state.settingsOpen;
        }
    },
    data() {
        return {
            
        };
    },
    methods: {
        
    }
}

</script>

<style scoped>

</style>
